import { useRoute } from 'vue-router/composables'
import { ref } from 'vue'
import { useHistoryStore } from '@/stores'
import { newTrack } from '@/track'

export function useBookRead() {
  const route = useRoute()

  const start = ref(new Date().getTime())
  const bookRead = function (bookInfo: any) {
    const end = new Date().getTime()
    const duration = end - start.value
    const historyStore = useHistoryStore()
    const prevPage: any = historyStore.$state.prevPage

    newTrack('biz_bookRead', {
      ...bookInfo,
      duration,
      title: route.meta?.title,
      host: window.location.origin,
      url: window.location.href,
      route_title: prevPage?.route_title,
      route_host: prevPage?.route_host,
      route_url: prevPage?.route_url,
    })
  }

  return {
    start,
    bookRead,
  }
}
